import React from 'react'
import Bredcom from './Utils/Bradcom';
import Gallery from './Utils/Gallery';

export default function Main() {
    
  return (
    <>
        <main>
            <Bredcom/>
            <Gallery/>
        </main>
    </>
  )
}
